/** 判断元素是否在视口内 */
function isElementInViewportWithCondition(el) {
    const rect = el.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;

    // 情况1：元素小于或等于视口 - 检查元素是否完全在视口内
    if (rect.height <= windowHeight && rect.width <= windowWidth) {
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= windowHeight &&
            rect.right <= windowWidth
        );
    }
    // 情况2：元素大于视口 - 元素和视口有交集 且 元素底部在视口底部之上
    else {
        // 判断是否有交集（水平和垂直方向都有重叠）
        const hasHorizontalIntersection = rect.left < windowWidth && rect.right > 0;
        const hasVerticalIntersection = rect.top < windowHeight && rect.bottom > 0;
        const hasIntersection = hasHorizontalIntersection && hasVerticalIntersection;

        // 判断元素底部是否在视口底部之上（元素的底部 <= 视口底部）
        const isBottomAboveViewportBottom = rect.bottom <= windowHeight;

        return hasIntersection && isBottomAboveViewportBottom;
    }
}

/**
 * 利用监听器去判断元素是否在视口内，并触发回调函数
 * @param {void ()} callback 
 * @returns 
 */
function createObserverToListenElementInViewport(callback) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const rect = entry.boundingClientRect;
            const windowHeight = window.innerHeight;

            // 判断元素是否大于视口
            const isLargerThanViewport = rect.height > windowHeight;

            if (isLargerThanViewport) {
                // 大元素：检查是否有交集且底部在视口底部之上
                const hasIntersection = entry.intersectionRatio > 0;
                const isBottomAboveViewportBottom = rect.bottom <= windowHeight;

                if (hasIntersection && isBottomAboveViewportBottom) {
                    // console.log('大元素满足条件');
                    // 触发自定义事件或回调
                    callback();
                }
            } else {
                // 小元素：检查是否完全可见
                if (entry.intersectionRatio === 1) {
                    // console.log('小元素完全可见');
                    callback();
                }
            }
        });
    }, {
        threshold: [0, 1] // 监听0和1两个阈值
    });

    return observer;
}



class FitDayNavigator extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        var scrollEventLock = false;
        const $headerEl = $('.header-wrapper');
        const $stickyBarEl = $(this);

        const clearActive = () => {
            const items = $('.fit-day-navigator__item');
            items.removeClass('active');
        };

        $('.fit-day-navigator__item').click(function (e) {
            const $el = $(e.currentTarget);
            const el = e.currentTarget;
            e.preventDefault();
            if (scrollEventLock) return;
            var goto = $el.attr('data-jump-scroll-to-name');
            if (!goto) return;
            clearActive();
            $el.addClass('active');
            let scrollTop = 0;
            scrollEventLock = true;
            // offset
            try {
                scrollTop = $(`[data-jump-scroll-name="${goto}"]`).offset()?.top ?? 0;
                // 由 sticky 元素导致的偏移量
                let offsetHeight = $headerEl.height() + $stickyBarEl.height();
                scrollTop > offsetHeight ? (scrollTop -= offsetHeight) : (scrollTop = 0);
                window.scroll({
                    top: scrollTop,
                    behavior: 'smooth',
                });
                setTimeout(() => (scrollEventLock = false), 700);
            } catch (e) {
                console.error(e);
            }
            // 移动端，选项滚动进视图
            const container = document.querySelector('.fit-day-navigator__list');
            const containerLeft = container.scrollLeft;
            const containerWidth = container.clientWidth;
            const itemLeft = el.offsetLeft;
            const itemWidth = el.offsetWidth;
            // console.log(containerLeft, containerWidth, itemLeft, itemWidth);
            if (itemLeft < containerLeft || itemLeft + itemWidth > containerLeft + containerWidth) {
                container.scroll({
                    left: itemLeft,
                    behavior: 'smooth',
                });
            }

            window.dataLayer.push({ "event_parameters": null });
            window.dataLayer.push({
                "event": "ga4Event",
                "event_name": "select_content_category",
                "event_parameters": {
                    "content_type": e.target.textContent,
                    "button_name": "Fit_Month_Introduction"
                }
            });
        });

        var ids = [...this.querySelectorAll('[data-jump-scroll-to-name]')].map((item) =>
            item.getAttribute('data-jump-scroll-to-name')
        );

        window.addEventListener('scroll', (e) => {
            setTimeout(() => {
                updateStickyBarTop();
            });
            const windowScrollTop = Math.max(
                window.pageYOffset,
                document.documentElement.scrollTop,
                document.body.scrollTop
            );
            const offsetWindowScrollTop = windowScrollTop;
            if (scrollEventLock) return;
            try {
                for (let i = 0; i < ids.length; i++) {
                    const offset =
                        ($(`[data-jump-scroll-name="${ids[i]}"]`).offset()?.top ?? Infinity) -
                        ($headerEl.height() + $stickyBarEl.height() + 2);
                    if (offsetWindowScrollTop > offset) {
                        clearActive();
                        $('.fit-day-navigator__item')[i].classList.add('active');
                    }
                }
            } catch (e) {
                console.error(e);
            }
        });

        function updateStickyBarTop() {
            const headerHeight = $headerEl.height();
            $stickyBarEl.css('top', headerHeight);
        }
        updateStickyBarTop();
    }
}

if (!customElements.get('fit-day-navigator')) {
    customElements.define('fit-day-navigator', FitDayNavigator);
}